
  $('input[type=radio]').on('change', function () {
      $('.discount__form_content_event-left_radio').removeClass('active');
      if ($(this).is(':checked')) {
          $(this).closest('.discount__form_content_event-left_radio').addClass('active');
      }
  });
  var name;
  var email;
  var type;
  var event;

  function getFormData(clasName) {

      if ($(clasName).val() == '') {
          if(clasName == '#discount_email'){
              return true;
          }
          $(clasName).css('border', '1px solid red');
          return false;
      } else {
          $(clasName).css('border', '1px solid #24bce2');
          return $(clasName).val();
      }
  }

  $('#discount_sbt').on('click', function () {
      name = getFormData('#discount_name')
      email = getFormData('#discount_email')
      type = getFormData('.discount__form_content_event-left_radio input[name="radio"]:checked')
      event = getFormData('#discount_event')
      if (name && email && type && event) {
          $('.discount__form_layout_scale >*').css('display', 'none')
          $('.discount__form_layout_scale').append
              ('<div class="discount__form_layout_scale_success" style="color: #24bce2;font-size: 20px;">Submitting...</div>')
          sendEmail()
      }
  });

  function sendEmail() {
      emailjs.init("dboTb2n7tvToN-CZm");
      var templateParams = {
          to_name: name,
          from_name: name,
          from_gmail: email,
          from_Competition: type,
          from_Join_Competition: event,
          message: "test"
      }
      emailjs.send('service_lmqzs3h', 'template_my6ov2d', templateParams)
          .then(function (response) {
              console.log('SUCCESS!', response.status, response.text);
              $('.discount__form_layout_scale_success').html('<p class="code">Code:RaceSumarpo20</p><a class="code_a" href="https://eu.sumarpo.com/pages/triathlon">Shop Triathlon</a><a class="code_a" href="https://eu.sumarpo.com/pages/swimrun-sports">Shop Swimrun</a>')
          }, function (error) {
              console.log('FAILED...', error);
          });
  }